"use client";

import React from "react";
import DposSessionStep from "./DposSessionStep";

interface PayLinkSessionStepProps {
  amount: string;
  onBack: () => void;
  onClose: () => void;
  onCreateNewPayment: () => void;
}

export default function PayLinkSessionStep({
  amount,
  onBack,
  onClose,
  onCreateNewPayment,
}: PayLinkSessionStepProps) {
  return (
    <DposSessionStep
      amount={amount}
      mode="paylink"
      onBack={onBack}
      onClose={onClose}
      onCreateNewPayment={onCreateNewPayment}
    />
  );
}
